import MonitoringScreen from './monitoring';
import ReportReceivableScreen from './receivable';
import ReportOutstandingScreen from './outstanding';
import ReportReceivableCustomerScreen from './receivable_customer';
import ReportAgingScreen from './aging';

const routes = [
  {
    path: '/report/monitoring',
    component: MonitoringScreen,
  },
  {
    path: '/report/receivable',
    component: ReportReceivableScreen,
  },
  {
    path: '/report/outstanding',
    component: ReportOutstandingScreen,
  },
  {
    path: '/report/receivable/customer',
    component: ReportReceivableCustomerScreen,
  },
  {
    path: '/report/aging/:id',
    component: ReportAgingScreen,
  },
];

export default routes;
